import { Star } from './star'

export default {
  Star
}
